import { MContentHeaderProps } from '../../molecules/MContentHeader/MContentHeader.types';

export interface OMiniCardContainerProps {
  desktopColumns?: string;
  mContentHeader?: MContentHeaderProps;
  cqPath?: string;
  pagePath?: string;
  itemPath?: string;
  className?: string;
  trackingProperties?: OMiniCardContainerTrackingProperties;
}

export interface OMiniCardContainerTrackingProperties {
  additionalTrackingVariables?: string;
  enableScrollingBehavior?: boolean;
  trackingDescription?: string;
  impressionTrack?: boolean;
  description?: string;
  trackingContentPosition?: string;
  faicUrl?: string;
  faicMCD?: string;
  atCCeVar48?: string;
  rightArrowDesc?: string;
  cardLocation?: string;
  leftArrowDesc?: string;
  clickTrack?: boolean;
  location?: string;
  merchandisingCategory?: string;
  impressionCount?: boolean;
  trackingTag?: string;
  trackingOfferType?: string;
}

export enum OMiniCardContainerDesktopColumns {
  Two = '2',
  Three = '3',
}
